import { message } from 'antd';
import { authHeader } from '../../../../helpers/auth-header';
import { client } from '../../../../actions';
import uri from '../../constants/uri';
import actions from '../actions/actions';
import moment from 'moment';
import { fromDateStr, toDateStr } from '../../../../helpers/utcDate';
import { typeShortNameMap } from '../../constants/typeShortNameMap';

const createAddress = (debt) => {
  const { street, house, corps, flat, flatTypeId } = debt;

  const houseText = house ? `д. ${house}` : undefined;
  const corpsText = corps ? `к. ${corps}` : undefined;
  const flatText = flat
    ? flatTypeId
      ? `${typeShortNameMap[flatTypeId]} ${flat}`
      : `кв. ${flat}`
    : undefined;

  return [street, houseText, corpsText, flatText].filter(Boolean).join(', ');
};

const getDebtsList =
  ({ fileId, flatId, streetId, houseId, account, phone, debt, months }) =>
  async (dispatch, getState) => {
    const uploadTime = getState().openedFile?.uploadTime;
    try {
      dispatch({ type: actions.DEBTS_LIST_LOADING });
      const responce = await client.get(`${uri}/lists`, {
        headers: authHeader(),
        params: {
          fileId,
          flatId,
          streetId,
          houseId,
          account,
          phone,
          debt,
          from_date: months
            ? fromDateStr(moment(uploadTime).subtract(months, 'months'))
            : undefined,
          to_date: months ? toDateStr(moment(uploadTime)) : undefined,
        },
      });
      dispatch({
        type: actions.DEBTS_LIST_LOADED,
        payload: responce.data.map((debt) => ({
          ...debt,
          dateOnset: moment(debt.dateOnset).format('DD.MM.YYYY'),
          address: createAddress(debt),
        })),
      });
      if (flatId || streetId || houseId || account || phone || debt || months) {
        dispatch({
          type: actions.FILTER_WORKED,
          payload: { flatId, streetId, houseId, account, phone, debt, months },
        });
      }
    } catch (error) {
      console.error(error);
      message.error(
        'При загрузке списка дебиторской задолженности произошла ошибка'
      );
    }
  };

export default getDebtsList;
